






























































import {
  defineComponent,
  reactive,
  computed,
  ref,
  onMounted,
  Ref,
  watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getRoles,
  createRole,
  deleteRole,
} from '@/api/index';

import CommonFormWithRoleEditor from '@/components/User/CommonFormWithRoleEditor.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import useAuth from '@/use/useAuth';

const Index = defineComponent({
  setup() {
    const { route } = useRouter();
    const { hasPermission } = useAuth();
    const refetchQuery = ref(false);
    const tempRoleDelete = -1;
    const confirmModal = ref(null);
    const getRoleDisplayFromRoute = '';
    const resultGetRole: any[] = [];
    const roles: Ref<{ id: number; name: string }[]> = ref([]);
    async function getRoleData() {
      const result = await getRoles({});
      roles.value = result.data;
    }
    onMounted(async () => {
      await getRoleData();
    });

    const formCreate = reactive({
      name: '',
      call: async () => {
        const result = await createRole({ name: formCreate.name });
        await getRoleData();
        (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
    });
    async function deleteRoleFunction(id: number) {
      await deleteRole(id);
      await getRoleData();
    }

    // ==== Use Format ==== //
    function useDateTimeFormat(date: any) {
      if (!date) return '';
      return `${useFormat
        .date(date)
        .displayShortThaiDate()} เวลา ${date.substring(11, 16)}`;
    }

    watch(() => route.value.params.roleId, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        refetchQuery.value = true;
      }
    });

    watch(() => refetchQuery.value, async (newVal) => {
      if (newVal) {
        await getRoleData();
        refetchQuery.value = false;
      }
    });

    return {
      roles,
      refetchQuery,
      formCreate,
      tempRoleDelete,
      // User list gql
      useDateTimeFormat,
      resultGetRole,
      getRoleDisplayFromRoute,
      getRoleData,
      deleteRoleFunction,
    };
  },
  components: {
    CommonModalWithPreset,
    CommonFormWithRoleEditor,
  },
});

export default Index;
